<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                model-def="callqueues"
                model-class="callqueue"
                :infos="infos"
                top-class=""
                :activities="true">

                <template slot="relations">
                    <belongstomany-show
                        class="pb-4"
                        :headers="infoData.fieldDefs"
                        title="Contatti"
                        paginate
                        :url="'business-callqueues-filters'"
                        :subFilters="{'callqueue_id': id}"
                        :show-expand="true">
                        <template v-slot:expanded-content="{ item }">
                            <callqueue-outcomes :key="'outcomes-' + item.id" :business-callqueue-id="item.id"></callqueue-outcomes>
                        </template>
                        <template slot="table-footer">
                            <v-row class="pa-0 ma-0" justify="center">
                                <v-col lg="3" md="4" sm="6" class="pt-0">
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mdi-phone</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Totale Contatti</v-list-item-title>
                                                <v-list-item-subtitle>{{ countCompanies }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </template>
                    </belongstomany-show>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>

    import CallqueueOutcomes from './CallqueueOutcomes'
    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {

        name: 'callqueue',
        components: {
            BelongstomanyShow,
            CallqueueOutcomes
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                relations: {},
                modelDef: 'callqueues',
                infoData: {},
            }
        },


        computed: {

            countCompanies() {
                if(this.models.callqueue && this.models.callqueue.companies_count) {
                    return this.models.callqueue.companies_count
                } else return 0
            },

            countCompaniesEmail() {
                if(this.models.callqueue && this.models.callqueue.companies_count) {
                    return this.models.callqueue.companies_count_email
                } else return 0
            },
        },

        created() {
            this.axios.get(this.modelDef + '/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos
                this.$store.commit('endProgress')
                this.load = true

            }, response => {
                // error callback
            })

            this.axios.get('callqueue-businesscallqueues-info').then(response => {
                this.infoData = response.data.info
            })
        }
    }
</script>
